import { render } from "./ResidentCharting.vue?vue&type=template&id=022a1792"
import script from "./ResidentCharting.vue?vue&type=script&lang=js"
export * from "./ResidentCharting.vue?vue&type=script&lang=js"

import "./ResidentCharting.vue?vue&type=style&index=0&id=022a1792&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__